const urlRoot = '/customers';

export const URL = {
    pushNotifications: `${urlRoot}/{id}/device-registration`,
};
